import { coachSessionRemarkV2Schema, getCoachSessionsSortOrderSchema } from '@airreading/common/data';
import { z } from 'zod';
import { paginationRequestSchema } from './pagination';

export const coachSessionListSearchSchema = paginationRequestSchema.extend({
  startOnOrAfter: z.string().optional(),
  endOnOrBefore: z.string().optional(),
  query: z.string().optional(),
  sortBy: getCoachSessionsSortOrderSchema.optional(),
  sessionRemarksV2: z.array(coachSessionRemarkV2Schema).optional(),
});
export type CoachSessionListRouteConstraint = z.infer<typeof coachSessionListSearchSchema>;
